import { render, staticRenderFns } from "./ModalAddManpower.vue?vue&type=template&id=247af975"
import script from "./ModalAddManpower.vue?vue&type=script&lang=ts"
export * from "./ModalAddManpower.vue?vue&type=script&lang=ts"
import style0 from "./ModalAddManpower.vue?vue&type=style&index=0&id=247af975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports